<template>
  <div id="scoreAnalysis">
    <!-- 面包屑 -- 批次下拉 -->
    <div class="title">
      <p>
        <span class="routerName">分数段统计</span>
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
        <span class="planName">{{currentPlan.planName}}</span>
        <el-dropdown trigger="click" style="margin-left: 8px;">
            <span class="el-dropdown-link">
            <img :src="planImg" alt="">
            </span>
            <template #dropdown>
            <el-dropdown-menu style="max-height:600px;height:auto;overflow-y:auto;">
                <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{item.planName}}</el-dropdown-item>
            </el-dropdown-menu>
            </template>
        </el-dropdown>
      </p>
    </div>

    <!-- 搜索表单 -->
    <ots-refer v-bind='$attrs' v-on='$listeners' :selectList="selectList" :requestForm='requestForm' @search="search" style="margin-top: 24px"></ots-refer>

    <!-- 表格 -- 分页 -->
    <div class="mainCon">
      <p class="icon_p" @click="SegmentSettings"><img :src="iconImg" alt=""><span>分数段设置</span></p>
      <el-table :data="tableData" style="width: 100%" >
        
        <el-table-column
          :prop="item.prop"
          :label="item.title"
          align="center"
          v-for="(item,index) in tableHeader"
          :key="index"
        >
          <template slot-scope="scope">
            <span class="table-text" v-html="getTableText(item, scope)">
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="item.title" v-for="(item,index) in tableHeader_Score" :key="index.title" align="center">
          <el-table-column
            v-for="(v,i) in item.headerList"
            :key="i"
            :prop="`sections[${index}][${v.prop}]`"
            :label="v.title"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table-text" v-html="getTableText_Score(v, scope, index)">
              </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="查看分布图" align="center">
          <template slot-scope="scope">
            <span class="table-text" style="color: #006AFF; cursor: pointer;" @click="showGreade(scope.row)">
              查看
            </span>
          </template>
        </el-table-column>


      </el-table>
      <ots-pagination v-bind='$attrs' v-on='$listeners' :pagination="pagination" @changeNum="changeNum" @changePage="changePage"></ots-pagination>
    </div>

    <!-- 分数段设置弹窗 -->
    <ots-custom-dialog :dialog.sync="AddSwiperDialog" title="分数段设置" width="640px">
      <template v-slot:content>
        <div class="exportDialog">
          <div class="ipScope">
            <div v-for="(item, index) in ipSetLits" :key="index" class="inputBox">
              <el-input v-model="item.ipBegin" placeholder="请输入"></el-input>
              <span> 至</span>
              <el-input v-model="item.ipEnd" placeholder="请输入"></el-input>
              <i v-if="index !== 0" class="el-icon-delete" @click="deletIp(index)"></i>
            </div>
            <span class="addIp" @click="addIp">+ 增加分数段</span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="AddSwiperDialog = false">取消</el-button>
        <el-button round type="primary" @click="AddSeg()">确定</el-button>
      </template>
    </ots-custom-dialog>


    
    <ots-custom-dialog :dialog.sync="GreadeDialog" :title="currentPlan.planName + ' -- 成绩分布图'" width="640px">
      <template v-slot:content>
        <div style="width: 572px; height: 400px;" id="gradeChat">
        </div>
        <div style="positon: relative;">
          <h3 class="coursePosition">{{ currentCourseName }}</h3>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="GreadeDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import {listByCourseFN,getPlanCourseList} from '@/http/modules/examReport'
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'

import { getTrialScoreLinePlanListApi, getPlanApi } from "@/http/modules/examSet/score";

export default {
  data(){
    return {
      // 成绩分布弹窗开关
      GreadeDialog: false,
      // 分数段弹窗开关
      AddSwiperDialog: false,
      // 分数段设置按钮图片
      iconImg: require('@/assets/img/shezhi.png'),
      // 批次列表图片
      planImg: require('@/assets/img/courseChange.png'),
      // 批次列表
      planList: [],
      // 当前选择批次
      currentPlan: {},
      // 请求表格参数
      requestForm: {
        planId: '',
        courseId: '',
        size: 10,
        page: 1,
        scoreTypeId: ''
      },
      // 搜索表单配置
      selectList: [
        {
          title: "考试科目",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [
            {courseName: '全部', courseId: ''}
          ],
        },
        {
          title:'成绩类型',
          type: "select",
          requestKey:'scoreTypeId',
          label: "name",
          value: "scoreTypeId",
          data: [
            // {name: '客观题成绩', scoreTypeId: '1'},
            // {name: '主观题成绩', scoreTypeId: '2'},
            // {name: '发布成绩', scoreTypeId: '3'},
            // {name: '发布前成绩', scoreTypeId: '4'}
          ],
        }
      ],
      // 表格数据
      tableData: [],
      // 表格头
      tableHeader: [
        {
          title: "考试科目",
          type: 'normal',
          prop: "courseName",
        },
        {
          title: "参考人数",
          type: 'normal',
          prop: "examedCount"
        },
        {
          title: "应考人数",
          type: 'normal',
          prop: "shouldExamCount"
        },
        {
          title: "平均分",
          prop: "avgScore"
        },
      ],
      // 分数段表格头
      tableHeader_Score: [
        {
          title: "【0-59】",
          type: 'stage',
          headerList: [
            {
              title: "人数",
              prop: "sectionCount"
            },
            {
              title: "百分比",
              prop: "sectionPercent"
            },
          ]
        },
        {
          title: "【60-100】",
          type: 'stage',
          headerList: [
            {
              title: "人数",
              prop: "sectionCount"
            },
            {
              title: "百分比",
              prop: "sectionPercent"
            },
          ]
        },
      ],
      // 分页
      pagination: {
          total: 0
      },
      // 分数段设置数据
      ipSetLits: [
        {
          ipBegin: "0",
          ipEnd: "59",
        },
        {
          ipBegin: "60",
          ipEnd: "100",
        },
      ],

      currentCourseName: "",
    }
  },
  watch: {
    'currentPlan': 'planIsChange'
  },
  created(){
    this.initData()
  },
  methods: {
    /**
     * @param { 展示成绩分布 }
     */
    showGreade(row) {
      this.currentCourseName = row.courseName
      this.GreadeDialog = true;
      this.$nextTick(() => {
        this.generatePie(row);
      })
    },

    /**
     * @param { 饼图生成 }
     */
    generatePie(row) {
      let data = [];
      row.sections.map(e=>{
        let item = { value: e.sectionPercent, name: e.sectionName.substring(1, e.sectionName.length - 1) }
        data.push(item);
      })

      document.getElementById('gradeChat').removeAttribute('_echarts_instance_');
      let myChart = this.$echarts.init(document.getElementById("gradeChat"));
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          top: 0,
        },
        series: [
          {
            name: '成绩分布',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            slient: true,
            itemStyle: {
              normal: {
                borderRadius: 10,
                color: function(colors) {
                  let list = ['#FF3725', '#FFA97E', '#FFDC73', '#B0DF2D', '#00D48A', '#00D9D2', '#3081F2', '#968CFF', '#D659FF', '#F255B1'];
                  return list[colors.dataIndex];
                }
              }
            },
            label: {
              show: true,
              position: 'outside',
              fontSize: 16,
              fontWeight: 'bold',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 24,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data
          }
        ]
      };
      option && myChart.setOption(option)

    },

    /********************************
     * @deletIp 删除分数段
     ********************************/
    deletIp(i) {
      this.ipSetLits = this.ipSetLits.filter((item, index, arr) => {
        return index !== i;
      });
    },

    /********************************
     * @addIp 添加分数段
     ********************************/
    addIp() {
      let ipReg = /^\d+(\.\d{1,2})?$/;
      let ipItem = { ipBegin: "", ipEnd: "" }
      for (let i = 0; i < this.ipSetLits.length; i++) {
        if (!this.ipSetLits[i].ipBegin || !this.ipSetLits[i].ipEnd) {
          this.$confirm("请设置完整的分数段范围", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            roundButton: true,
          })
          return
        } else if (!ipReg.test(this.ipSetLits[i].ipBegin) || !ipReg.test(this.ipSetLits[i].ipEnd)) {
          this.$confirm("请设置正确的的分数段范围", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            roundButton: true,
          })
          return
        }
      }
      if (this.ipSetLits.length > 14) {
        this.$confirm("分数段最多为15个！", "提示", { 
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          roundButton: true,
        })
        return
      }
      this.ipSetLits.push(ipItem)
    },

    /**
     * @param { 执行添加分数段 }
     */
    AddSeg(){
      // (1) 范围验证
      let ipReg = /^\d+(\.\d{1,2})?$/;
      for (let i = 0; i < this.ipSetLits.length; i++) {
        if (!this.ipSetLits[i].ipBegin || !this.ipSetLits[i].ipEnd) {
          this.$confirm("请设置完整的分数段范围", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            roundButton: true, 
          })
          return;
        } else if (!ipReg.test(this.ipSetLits[i].ipBegin) || !ipReg.test(this.ipSetLits[i].ipEnd)) {
          this.$confirm("请设置正确的的分数段范围", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            roundButton: true,
          })
          return;
        }
      }
      // (2) 重新查询表格
      this.search();
      // (3) 关闭弹窗
      this.AddSwiperDialog = false;
    },

    /********************************
     * @getTableText 单层表格数据处理
     ********************************/
    getTableText(item, scope ) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop];
      return text || text == "0" ? text : "-";
    },

    /********************************
     * @getTableText 动态多层表格数据处理
     ********************************/
    getTableText_Score(item, scope, index) {
      let text = scope.row.sections[index][item.prop];
      return text || text == "0" ? text : "-";
    },

    /********************************
     * @SegmentSettings 开启分数段弹窗
     ********************************/
    SegmentSettings() {
      this.AddSwiperDialog = true;
    },

    /********************************
     * @initData 初始化数据
     ********************************/
    async initData(){
      let { data, code } = await getTrialScoreLinePlanListApi({flag: 2});

      if(code == 1) {
        this.planList = data;
        this.currentPlan = data[0]
        this.requestForm.planId = data[0].planId;
      } 


    },

    /**
     * @param { 批次切换 }
     */
    async planIsChange(val){
      const { data, code } = await getPlanCourseList({planId: val.planId});
      if(code == 1) {
        this.selectList[0].data = [{courseName: '全部', courseId: ''}];
        this.selectList[0].data = this.selectList[0].data.concat(data);
      }

      const { data: planInfo } = await getPlanApi({planId: val.planId});
      let scorePublish = planInfo.scorePublish;

      let item = {};
      if(scorePublish == 1) {
        item = {name: '发布成绩', scoreTypeId: '3'}
        this.requestForm.scoreTypeId = '3';
      } else {
        item = {name: '发布前成绩', scoreTypeId: '4'}
        this.requestForm.scoreTypeId = '4';
      }

      let scoreTypeList = [
        {name: '客观题成绩', scoreTypeId: '1'},
        {name: '主观题成绩', scoreTypeId: '2'},
        item
      ]
      this.selectList[1].data = scoreTypeList;

      this.search()
    },

    /********************************
     * @changPlan 批次选择
     ********************************/
    changPlan(value){
      this.currentPlan = value
      this.requestForm.courseId = ''
      this.requestForm.planId = value.planId
    },

    /********************************
     * @search 搜索
     ********************************/
    search(){
      // (1) 基本参数
      let params = {...this.requestForm}
      // (2) 分数段设置参数
      params.sections = []
      this.ipSetLits.map(e=>{
        let item = e.ipBegin + '-' + e.ipEnd;
        params.sections.push(item);
      })
      params.sections = params.sections.join();
      // (3) 查表格
      listByCourseFN(params).then(res=>{
        if (res.code == 1) {
          this.tableData = res.data
          // (4) 添加分数段表格头
          this.tableHeader_Score = []
          this.ipSetLits.map(e=>{
            let item = {
              title: `【${e.ipBegin}-${e.ipEnd}】`,
              type: 'stage',
              headerList: [
                {
                  title: "人数",
                  prop: "sectionCount"
                },
                {
                  title: "百分比",
                  prop: "sectionPercent"
                },
              ]
            }
            this.tableHeader_Score.push(item)
          })
        }
      })
    },

    changeNum(num) {
      this.requestForm.size = num
      this.search()
    },

    changePage(p) {
      this.requestForm.page = p
      this.search()
    },

  }
}
</script>

<style scoped lang="less">
.coursePosition {
  width: 160px;
  position: absolute;
  text-align: center;
  top: calc(50% - 12px);
  left: calc(50% - 80px);
}

#scoreAnalysis {
  .title {
    height: 32px;
    p {
      .routerName {
        font-size: 14px;
        color: #9299A6;
      }
      .planName {
        font-size: 24px;
        font-weight: 500;
        color: #2D2F33;
      }
      .el-dropdown-link {
        cursor: pointer;
        color: var(--el-color-primary);
        display: flex;
        align-items: center;
      }
    }
  }
  .mainCon {
    margin-top: 16px;
    padding: 24px;
    background: #fff;
    border-radius: 8px;

    .icon_p {
      width: auto;
      height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
      span {
        color: #006AFF;
      }
    }
  }
}
  .ipScope {
    padding: 24px 32px;
    box-sizing: border-box;
    background: #f8f9fc;
    border-radius: 8px;
    h6 {
      color: #45494d;
      font-size: 14px;
      margin-bottom: 16px;
    }
    .inputBox {
      display: flex;
      height: 36px;
      line-height: 36px;
      justify-items: center;
      vertical-align: middle;
      margin-bottom: 8px;
      /deep/ .el-input {
        width: 180px;
        height: 36px;
        line-height: 36px;
      }
      span {
        margin: 0 11px;
      }
      i {
        margin: 12px 0 0 20px;
        color: #006aff;
      }
    }
    .addIp {
      color: #006aff;
      font-size: 14px;
    }
  /deep/ .el-radio-button__inner {
    margin-right: 8px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    padding: 10px 20px;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-checkbox-button__inner {
    margin-right: 8px;
  }

  /deep/ .el-input .el-input__inner {
    width: 160px;
    height: 36px;
    line-height: 18px;
  }

  }
  
</style>
